import { TOKEN_NAME } from '../constants/constants';

const getToken = () => {
  return localStorage.getItem(TOKEN_NAME);
};

const httpConfig = {
  mode: 'cors', // no-cors, cors, *same-origin
  cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
  credentials: 'same-origin', // include, *same-origin, omit
  headers: {
    'Content-Type': 'application/json; charset=utf-8',
    Token: getToken()
  }
};

const http = {
  get: () => ({
    method: 'GET',
    ...httpConfig
  }),
  post: (payload) => ({
    method: 'POST',
    ...httpConfig,
    body: JSON.stringify(payload)
  }),
  put: (payload) => ({
    method: 'PUT',
    ...httpConfig,
    body: JSON.stringify(payload)
  }),
  delete: () => ({
    method: 'DELETE',
    ...httpConfig
  }),
  postForm: (formData) => {
    return getConfigForForm(formData, 'POST');
  }
};

function getConfigForForm(formData, method) {
  const config = {
    method: method,
    ...httpConfig,
    headers: { ...httpConfig.headers },
    body: formData
  };
  delete config.headers['Content-Type'];
  return config;
}

export default http;
